import { HIDDEN } from '../classnames/design-system';
import { ACTIVE_SIDE_BAR } from '../classnames/sidebar-popup';
import ProductFlavorManager from '../above-the-fold/product-flavor-manager';
import { SELECTORS } from './constants';

export class ProductBarManager {
  constructor(container) {
    this.productFlavorManager = new ProductFlavorManager(container, this.onChange);
  }

  onChangeSidebar = (productId) => {
    const sideBars = document.querySelectorAll(`.${SELECTORS.PRODUCT_PURCHASE_SIDE_BAR}`);

    [...sideBars].forEach((sideBar) => {
      if (sideBar.dataset.productId === productId) {
        sideBar.classList.add(ACTIVE_SIDE_BAR);
      } else {
        sideBar.classList.remove(ACTIVE_SIDE_BAR);
      }
    });
  };

  onChangePurchaseBar = (productId) => {
    const purchaseBars = document.querySelectorAll(`.${SELECTORS.PRODUCT_PURCHASE_BAR}`);

    [...purchaseBars].forEach((purchaseBar) => {
      if (purchaseBar.dataset.productId === productId) {
        purchaseBar.classList.remove(HIDDEN);
      } else {
        purchaseBar.classList.add(HIDDEN);
      }
    });
  };

  onChange = (productId) => {
    this.onChangeSidebar(productId);
    this.onChangePurchaseBar(productId);
  };

  initializeEventListeners = () => {
    this.productFlavorManager.initializeEventListeners();
  };
}
